import { render, staticRenderFns } from "./fcwpSpecials.vue?vue&type=template&id=1e8fa27b&scoped=true&"
import script from "./fcwpSpecials.vue?vue&type=script&lang=js&"
export * from "./fcwpSpecials.vue?vue&type=script&lang=js&"
import style0 from "./fcwpSpecials.vue?vue&type=style&index=0&id=1e8fa27b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8fa27b",
  null
  
)

export default component.exports